export default __webpack_public_path__ + "static/media/email.da002266.svg";